import { render, staticRenderFns } from "./TicketAssistPage.vue?vue&type=template&id=1b4b4f15&scoped=true&"
import script from "./TicketAssistPage.vue?vue&type=script&lang=js&"
export * from "./TicketAssistPage.vue?vue&type=script&lang=js&"
import style0 from "./TicketAssistPage.vue?vue&type=style&index=0&id=1b4b4f15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b4f15",
  null
  
)

export default component.exports